import { useQuery } from "@tanstack/react-query";
import { z } from "zod";

import { useAuth } from "@/contexts/auth/useAuth";
import { useApi } from "@/hooks";

import { MfaQueryKeys } from "../query-keys";

const mfaSetupSchema = z.object({
  key: z.string(),
  provisioning_uri: z.string(),
});

function useMfaSetup() {
  const api = useApi();
  const { currentAccount } = useAuth();

  return useQuery({
    enabled: !!currentAccount,
    queryKey: MfaQueryKeys.setup(currentAccount?.id),
    queryFn: async () => {
      const { data } = await api.get("/api/pleroma/accounts/mfa/setup/totp");
      return mfaSetupSchema.parse(data);
    },
  });
}

export { useMfaSetup };
